import { push } from "connected-react-router";

import * as types from "./actionTypes";
import { showModalSuccess } from "./modalActions";
import { showAlertSuccess } from "./alertActions";
import ptoRequestService from "../services/ptoRequestService";

export function loadPtoRequestSuccess(ptoRequests) {
  return {
    type: types.LOAD_PTOREQUEST_SUCCESS,
    ptoRequests
  };
}

export function getPtoRequestSuccess(ptoRequest) {
  return { type: types.GET_PTOREQUEST_SUCCESS, ptoRequest };
}

export function loadingPtoRequest(status = true) {
  return {
    type: types.LOADING_PTOREQUEST,
    loadingPtoRequest: status
  };
}

export function savingPtoRequest(status = true) {
  return { type: types.SAVING_PTOREQUEST, savingPtoRequest: status };
}

export function createPtoRequestSuccess(ptoRequest) {
  return { type: types.CREATE_PTOREQUEST_SUCCESS, ptoRequest };
}

export function updatePtoRequestSuccess(ptoRequest) {
  return { type: types.UPDATE_PTOREQUEST_SUCCESS, ptoRequest };
}

export function deletePtoRequestSuccess(ptoRequestId) {
  return { type: types.DELETE_PTOREQUEST_SUCCESS, ptoRequestId };
}

export function requestPtoRequestId(ptoRequestId) {
  return (dispatch) => {
    dispatch({
      type: types.REQUEST_PTOREQUEST_ID,
      ptoRequestToDelete: ptoRequestId
    });
    dispatch(showModalSuccess("ptoRequestDeleteModal"));
  };
}

export function loadPtoRequests(query) {
  return (dispatch) =>
    ptoRequestService
      .get(query)
      .then((data) => dispatch(loadPtoRequestSuccess(data)))
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function loadPtoRequestsByCustomerId(id) {
  return (dispatch) =>
    ptoRequestService
      .loadPtoRequestsByCustomerId(id)
      .then((data) => dispatch(loadPtoRequestSuccess(data)))
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function loadPtoRequestsByEmployeeId(id) {
  return (dispatch) =>
    ptoRequestService
      .loadPtoRequestsByEmployeeId(id)
      .then((data) => dispatch(loadPtoRequestSuccess(data)))
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function loadPtoRequestsByFilters(body) {
  return (dispatch) =>
    ptoRequestService
      .loadPtoRequestsByFilters(body)
      .then((data) => {
        dispatch(loadPtoRequestSuccess(data));

        return data;
      })
      .catch((error) =>
        dispatch(showAlertSuccess("Unable to load ptoRequest.", error))
      );
}

export function getPtoRequest(id) {
  return (dispatch) =>
    ptoRequestService
      .getPtoRequest(id)
      .then((ptoRequest) => {
        dispatch(getPtoRequestSuccess(ptoRequest));
        // if (showEXPENSEDetails) {
        //     dispatch(showModalSuccess("ptoRequestDetailsModal"));
        // }
      })
      .catch((error) => {
        dispatch(showAlertSuccess(error.description, "error"));
      });
}

export function createPtoRequest(ptoRequest) {
  return (dispatch) => {
    dispatch(savingPtoRequest());
    return ptoRequestService
      .createPtoRequest(ptoRequest)
      .then((createdPtoRequest) => {
        dispatch(savingPtoRequest(false));
        if (createdPtoRequest.status === 200) {
          dispatch(createPtoRequestSuccess(createdPtoRequest));
          dispatch(
            showAlertSuccess("PtoRequest created successfully", "success")
          );
          dispatch(push("/app/pto"));
        } else {
          dispatch(
            showAlertSuccess(
              "Duplicate PTO request, please cancel the original request or select a new date",
              "error"
            )
          );
        }
      })
      .catch((error) => {
        dispatch(savingPtoRequest(false));
        dispatch(showAlertSuccess(error, "error"));
      });
  };
}

export function updatePtoRequest(ptoRequest) {
  return (dispatch) => {
    dispatch(savingPtoRequest());
    return ptoRequestService
      .updatePtoRequest(ptoRequest)
      .then((updatedPtoRequest) => {
        // dispatch(updatePtoRequestSuccess(updatedPtoRequest));
        dispatch(savingPtoRequest(false));
        dispatch(
          showAlertSuccess("PtoRequest updated successfully", "success")
        );
        return updatedPtoRequest;
      })
      .catch(({ response }) => {
        dispatch(savingPtoRequest(false));
        dispatch(showAlertSuccess(response.data.errors.message, "error"));
      });
  };
}

export function deletePtoRequest(id) {
  return (dispatch) =>
    ptoRequestService
      .deletePtoRequest(id)
      .then(() => {
        dispatch(deletePtoRequestSuccess(id));
        dispatch(
          showAlertSuccess("PtoRequest deleted successfully", "success")
        );
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function getPtoRequestBalance(id) {
  return (dispatch) =>
    ptoRequestService.getPtoRequestBalance(id).then((data) => {
      dispatch({
        type: types.LOAD_PTOSUMMARY_SUCCESS,
        ptoBalance: data
      });
    });
}
